import { render } from "./Login.vue?vue&type=template&id=f5525a6a&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=f5525a6a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f5525a6a"

export default script